const particleConfigs = {
  particles: {
    number: {
      value: 5,
      density: {
        enable: true,
        value_area: 700,
      },
    },
    color: {
      value: "#7ca7ff",
    },
    shape: {
      type: "star",
      stroke: {
        width: 0.7,
        color: "#7ca7ff",
      },
      polygon: {
        nb_sides: 3,
      },
      image: {
        src: "img/github.svg",
        width: 100,
        height: 100,
      },
    },
    opacity: {
      value: 0.31213734042978925,
      random: false,
      anim: {
        enable: false,
        speed: 1,
        opacity_min: 0.1,
        sync: false,
      },
    },
    size: {
      value: 4,
      random: true,
      anim: {
        enable: false,
        speed: 100,
        size_min: 0.9,
        sync: false,
      },
    },
    line_linked: {
      enable: true,
      distance: 150,
      color: "#ffffff",
      opacity: 0.4,
      width: 1,
    },
    move: {
      enable: true,
      speed: 1,
      direction: "none",
      random: true,
      straight: false,
      out_mode: "bounce",
      bounce: false,
      attract: {
        enable: true,
        rotateX: 600,
        rotateY: 1200,
      },
    },
  },
  interactivity: {
    detect_on: "window",
    events: {
      onhover: {
        enable: true,
        mode: "grab",
      },
      onclick: {
        enable: true,
        mode: "bubble",
      },
      resize: true,
    },
    modes: {
      grab: {
        distance: 109.43313635368786,
        line_linked: {
          opacity: 0.8375690789203574,
        },
      },
      bubble: {
        distance: 97.27389898105586,
        size: 7,
        duration: 0.7,
        opacity: 0.6890234511158123,
        speed: 3,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
      push: {
        particles_nb: 4,
      },
      remove: {
        particles_nb: 2,
      },
    },
  },
  retina_detect: false,
};

export default particleConfigs;